import React, { useEffect } from 'react';
import { Navigate, useLocation, Link } from 'react-router-dom';
import './ThankYou.css';

const PHONE_DISPLAY = '0330 133 4433';
const PHONE_HREF = 'tel:03301334433';
const WHATSAPP_HREF = 'https://wa.me/message/O2E665HYYHONE1';

const ThankYou = () => {
  const location = useLocation();
  const allowed = location.state?.fromForm === true;
  const submissionId = location.state?.submissionId;

  useEffect(() => {
    if (!allowed || !submissionId) return;
    const key = `lpa_conv_fired_${submissionId}`;
    if (sessionStorage.getItem(key)) return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', {
      send_to: 'AW-18123902787/3lpJCJWq6KMcEMOek8JD',
      value: 349,
      currency: 'GBP',
    });
    sessionStorage.setItem(key, '1');
  }, [allowed, submissionId]);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <div className="thank-you-icon" aria-hidden="true">
          <svg width="72" height="72" viewBox="0 0 72 72" fill="none">
            <circle cx="36" cy="36" r="36" fill="var(--accent-pale)" />
            <path
              d="M22 36.5L31 45.5L50 27"
              stroke="var(--accent)"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className="thank-you-title">Thank you &mdash; we&rsquo;ll be in touch shortly.</h1>
        <p className="thank-you-subtitle">
          One of our LPA specialists will contact you within 1 business day to discuss your requirements.
        </p>

        <div className="thank-you-card">
          <p className="thank-you-reassurance">
            You&rsquo;ve taken an important step in protecting what matters most.
          </p>
          <p className="thank-you-reassurance">
            While you wait, here&rsquo;s what happens next:
          </p>

          <ol className="thank-you-steps">
            <li>
              <span className="thank-you-step-number">1</span>
              <div>
                <strong>We review your enquiry</strong>
                <span>We look at your details and prepare for your consultation.</span>
              </div>
            </li>
            <li>
              <span className="thank-you-step-number">2</span>
              <div>
                <strong>We call you</strong>
                <span>One of our specialists will call at a time that suits you.</span>
              </div>
            </li>
            <li>
              <span className="thank-you-step-number">3</span>
              <div>
                <strong>We guide you through everything</strong>
                <span>From document preparation to OPG registration.</span>
              </div>
            </li>
          </ol>
        </div>

        <div className="thank-you-contact">
          <p className="thank-you-contact-intro">Need to reach us sooner?</p>
          <div className="thank-you-contact-actions">
            <a href={PHONE_HREF} className="thank-you-contact-btn thank-you-contact-btn--phone">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{PHONE_DISPLAY}</span>
            </a>
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noopener noreferrer"
              className="thank-you-contact-btn thank-you-contact-btn--whatsapp"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
              </svg>
              <span>Message on WhatsApp</span>
            </a>
          </div>
        </div>

        <Link to="/" className="thank-you-home-link">Return to homepage</Link>
      </div>
    </div>
  );
};

export default ThankYou;
